import { render, staticRenderFns } from "./cross-view-container.vue?vue&type=template&id=360361c8&scoped=true"
import script from "./cross-view-container.vue?vue&type=script&lang=js"
export * from "./cross-view-container.vue?vue&type=script&lang=js"
import style0 from "./cross-view-container.vue?vue&type=style&index=0&id=360361c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360361c8",
  null
  
)

export default component.exports